import { enqueueSnackbar } from 'actions';
import { DownloadFile } from 'actions/sessionActions.js';

import {
	GetSitesRequest,
	GetNbrRelationsLastUpdateRequest
} from '../requests/NbrRelationsValidationRequests.js';

import {
	GetHealthChecksExportRequest,
} from '../requests/HealthChecksRequests.js';

export const SET_FORM_STATE = 'SET_FORM_STATE';
export const GET_NBRRELATIONS_LAST_UPDATE = 'GET_NBRRELATIONS_LAST_UPDATE';
export const GET_SITES = 'GET_SITES';

const onSetFormState = (value) => ({
	type: SET_FORM_STATE,
	formState: value
});

export const SetFormState = (value) => (dispatch) => {
	dispatch(onSetFormState(value));
};

const onGetNbrRelationsLastUpdate = (value) => ({
	type: GET_NBRRELATIONS_LAST_UPDATE,
	nbrRelationsLastUpdate: value
});

export const GetNbrRelationsLastUpdate = () => async (dispatch) => {
	await GetNbrRelationsLastUpdateRequest().then(response => {
		dispatch(onGetNbrRelationsLastUpdate(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

const onGetSites = (value) => ({
	type: GET_SITES,
	sites: value
});

export const GetSites = () => async (dispatch) => {
	await GetSitesRequest().then(response => {
		dispatch(onGetSites(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetHealthChecksExport = (siteId, userId) => async (dispatch) => {
	await GetHealthChecksExportRequest(siteId, userId).then(response => {
		if (response.data.includes(':\\')) {
			dispatch(DownloadFile(response.data));
		} else {
			dispatch(enqueueSnackbar({ message: response.data, options: { variant: 'success' } }));
		}
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};
